import { Container, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import BoxContainer from "../../components/container/boxContainer";
import ProviderCard from "../../components/cards/ProviderCard";
import Filters from "./Filters";
import SchoolData from "../../json/Schools.json";
import { useNavigate } from "react-router-dom";

const AllSchools = () => {
  const navigate = useNavigate();
  const [locations, setLocations] = useState();
  const [platform, setPlatform] = useState();
  const [applicationForm, setApplicationForm] = useState();

  const handleNavigateToDetail = (row) => {
    let result = row.name.toLowerCase().replace(/\s+/g, "-");
    navigate(`/education-city/${result}`, { state: row });
  };

  return (
    <Container sx={{ maxWidth: "1100px !important", my: 6 }}>
      <Container maxWidth={"sm"} sx={{ p: 0, mb: 4 }}>
        <Typography
          variant="heading_services"
          component={"h1"}
          textAlign={"center"}
          lineHeight={"normal"}
        >
          Select A Best Furture For Your Children
        </Typography>
      </Container>
      <Filters
        location={locations}
        setLocation={setLocations}
        platform={platform}
        setPlatform={setPlatform}
        applicationForm={applicationForm}
        setApplicationForm={setApplicationForm}
      />
      <BoxContainer sx={{ mt: 3 }}>
        <Typography variant="h6" fontWeight={600}>
          All Schools
        </Typography>
      </BoxContainer>

      <Stack gap={{ xs: 2, md: 0 }}>
        {SchoolData.map((item, index) => (
          <ProviderCard
            key={index}
            data={item}
            index={index}
            handleClickOnCard={handleNavigateToDetail}
          />
        ))}
      </Stack>
    </Container>
  );
};

export default AllSchools;
